import './App.css';
import WeatherPage from './pages/WeatherPages';
import Logo from './components/Logos';
import Copyright from './components/Copyright';

function App() {
  return (
    <div className="App">
      <Logo />
      <WeatherPage />
      <Copyright />
    </div>
  );
}

export default App;